import React from 'react';
import proptypes from 'prop-types';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';

const { func } = proptypes;

export const LoadingError = ({ onReloadClick }) => {

  return (
    <div className="sui-outline sui-outline-offset-1 sui-outline-1 sui-rounded-base sui-outline-strong sui-p-4 sui-m-1 sui-text-center">
      <div className="sui-flex sui-items-start sui-justify-center sui-gap-3 sui-px-4">
        <InfoFilled color="danger" />
        <div>
          <Typography variant="body-base" weight="bold" color="danger" component="span">
            We&apos;re sorry,
            {' '}
          </Typography>
          <Typography variant="body-base" color="danger" component="span">
            an error occurred while loading your options. Please refresh and try again.
          </Typography>
        </div>
      </div>
      <div className="sui-flex sui-justify-center sui-pt-4">
        <Button
          variant="tertiary"
          onClick={() => onReloadClick()}
        >
          Reload Options
        </Button>
      </div>
    </div>
  );
};

LoadingError.propTypes = {
  onReloadClick: func.isRequired
};